import React from "react";
import * as classNames from "classnames";
import styles from "./mediaContainer.css";

export const MediaContainer = ({ className, onClick, children, image }) => {
	const allClassNames = classNames(styles.mediaContainer, className);

	return (
		<div className={allClassNames} onClick={onClick}>
			<div className={styles.mediaWrap}>
				<img className={styles.media} src={image} alt="" />
				{children}
			</div>
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/components/ui/mediaContainer/mediaContainer.js